<template>
  <div class="header">
    <div class="h-left">
      <img src="../assets/imges/logo.png" alt="" class="logo" />
    </div>
    <el-main style="padding: 0;">
      <div class="h-right" ref="hRightRef">
        <div class="h-tabpabe">
          <!-- 标签页 -->
          <Tabpabe :style="{ width: tabMaxWidth + 'px' }"> </Tabpabe>
        </div>
        <div class="h-info" ref="hInfoRef">
          <!-- 工作状态 -->
          <div class="work-status">
            <div v-if="service_id > 0" class="work-status-item">
              繁忙状态：
              <el-switch @change="changeStatus" v-model="busyworkStatus" active-color="#409EFF" inactive-color="#ccc">
              </el-switch>
            </div>
            <div v-if="service_id > 0" class="work-status-item">
              工作状态：
              <el-switch @change="changeOnlineStatus" v-model="workStatus" active-color="#409EFF" inactive-color="#ccc">
              </el-switch>
            </div>
            <div class="chatTotal">
              剩余可接待数量：<span style="color:#e6a23c">{{ chatTotal ? 600 - chatTotal : 0 }}</span>
            </div>
          </div>
          <div class="nick-info">
            <img src="../assets/imges/头像.png" alt="" />
            <span style="color: #000000;">{{ nickname }} </span>
            <div class="close" @click="close">
              <img src="../assets/imges/icon退出登录.png" alt="" /><span style="color: #000000;">退出登录</span>
            </div>
          </div>
        </div>
      </div>
    </el-main>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import Tabpabe from '@/components/tabpabe.vue'
import {
  getServiceID,
} from "@/utils/auth";
import { userServiceDetail, getChatGroup } from '@/api/service/index.js'
import { addUserService } from '@/api/service/index.js'
export default {
  data() {
    return {
      busyworkStatus: false,//繁忙状态
      workStatus: false, //咨询客服接待状态  在线/离线
      service_id: 0, //咨询客服id
      chatTotal: 0, // 可接待群组数量
      tabMaxWidth: 0, // 存储tab的最大宽度
      resizeHandler: null, // 存储防抖函数
    }
  },
  components: {
    Tabpabe
  },
  methods: {
    // 防抖函数（避免resize高频触发）
    debounce(fn, delay) {
      let timer = null;
      return function () {
        clearTimeout(timer);
        timer = setTimeout(() => {
          fn.apply(this, arguments);
        }, delay);
      };
    },
    calcTabMaxWidth() {
      if (!this.$refs.hInfoRef || !this.$refs.hRightRef) return;
      const hInfoWidth = this.$refs.hInfoRef.getBoundingClientRect().width;
      const hRightWidth = this.$refs.hRightRef.getBoundingClientRect().width;
      this.tabMaxWidth = hRightWidth - hInfoWidth - 10;
      if (this.tabMaxWidth < 300) this.tabMaxWidth = 300;
      console.log('最新tabMaxWidth：', this.tabMaxWidth); // 加日志验证
    },
    close() {
      this.$confirm('是否确认退出登录', '退出登录', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确认退出',
        cancelButtonText: '取消'
      })
        .then(() => {
          sessionStorage.clear()
          this.$router.push('/login')
        }).catch(action => { })

    },
    //更改咨询客服的繁忙状态
    changeStatus(e) {
      var param = {
        ids: this.service_id,
        is_busy: e ? "1" : "2",
      };
      addUserService(param).then((res) => {
        if (res.code == 1) {
          this.$message_c('设置成功')
          this.getServiceDetail();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //更改咨询客服的在线状态
    changeOnlineStatus(e) {
      var param = {
        ids: this.service_id,
        status: e ? "1" : "2",
      };
      addUserService(param).then((res) => {
        if (res.code == 1) {
          this.$message_c('设置成功')
          this.getServiceDetail();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 获取可接待数量
    getChatNum() {
      getChatGroup({}).then(res => {
        if (res.code == 1) {
          this.chatTotal = res.data.total
        }
      })
    },
    //获取咨询客服的详情
    getServiceDetail() {
      var param = {
        ids: this.service_id,
      };
      userServiceDetail(param).then((res) => {
        if (res.code == 1) {
          this.workStatus = res.data.status == 1 ? true : false;
          this.busyworkStatus = res.data.is_busy == 1 ? true : false;
        }
      });
    },
  },
  mounted() {
    this.service_id = getServiceID()
    //获取可接待数量
    this.getChatNum()
    //获取客服状态详情
    this.getServiceDetail()
    //初始化计算宽度
    this.$nextTick(() => {
      this.calcTabMaxWidth();
    });
    // 用防抖函数监听resize
    this.resizeHandler = this.debounce(this.calcTabMaxWidth, 100);
    window.addEventListener('resize', this.resizeHandler);
  },
  beforeDestroy() {
    //销毁监听，避免内存泄漏
    window.removeEventListener('resize', this.resizeHandler);
  },
  computed: {
    ...mapState('role', ['nickname']),
  }

}
</script>

<style lang="scss" scoped>
.header {
  height: 100%;
  width: 100%;
  border-bottom: 1px solid #f7f8fa;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;

  .h-left,
  .h-right {
    display: flex;
    align-items: center;
    height: 100%;
    font-size: 12px;

  }

  .h-left {
    width: 210px;
  }

  .h-right {
    flex: 1;
  }

  .h-tabpabe,
  .h-info {
    display: flex;
    align-items: center;
    height: 100%;
    font-size: 12px;
  }

  .h-tabpabe {
    flex: 1;
    justify-content: space-between;
    padding-right: 10px;
    box-shadow: border-box;
    min-width: 300px;
    overflow: hidden;

  }

  .h-info {
    .work-status {
      display: flex;
      align-items: center;
      min-width: 50px;

      .work-status-item {
        display: flex;
        width: 110px;
      }

      .chatTotal {
        margin-left: 10px;
        width: 140px;
      }
    }

    .nick-info {

      display: flex;
      flex: 1;
      align-items: center;

      .close {
        display: flex;
        align-items: center;
        padding-left: 10px;
      }

      .close:hover {
        cursor: pointer;
      }
    }

  }
}

.logo {
  width: 212px;
  height: 42px;
}
</style>